import uniqueId from 'lodash/uniqueId';

import { rHandler } from '@/plugins/RHandler';
import { DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import { apiService } from '@/services/APIService';

const LOCAL_ID_PREFIX = 'local_';

export default class BaseModel {
  constructor(response, url) {
    this.response = response;

    this.url = url;

    this.id = response.id || uniqueId(LOCAL_ID_PREFIX);
    this.name = response.name;
  }

  get isServer() {
    return !this.id.startsWith?.(LOCAL_ID_PREFIX);
  }

  update(rParams = DEFAULT_PARAMS) {
    const { data, obs } = rParams;
    return rHandler(
      apiService.put(`${this.url}/${this.id}`, data),
      (response) => {
        Object.assign(this, data);
        return { response };
      },
      (error) => ({ error }),
      obs,
    );
  }

  delete() {
    return rHandler(
      apiService.delete(`${this.url}/${this.id}`),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }

  getSerializedFieldsForTemplate(fields) {
    const form = {};

    Object.entries(this).forEach(([key, value]) => {
      const field = fields.find((f) => f.field === key);
      if (field) {
        form[key] = {
          default_value: value,
          can_user_update: field.can_user_update,
          can_cascade_update: field.can_cascade_update,
        };
      }
    });
    return form;
  }
}
